import { inject, Injectable } from '@angular/core';
import { IrisDeeplLanguage, IrisDeeplPayloadI, IrisDeeplResultI } from '@iris/common/models/IrisDeeplLanguage';
import { ApiUrl, IrisBaseCRUDService } from '@iris/api-query';
import { IrisLanguageI } from '@iris/common/models/IrisLanguage';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IrisUserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class IrisDeeplTranslationService extends IrisBaseCRUDService<IrisLanguageI> {
  private readonly userService = inject(IrisUserService);

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  }

  @ApiUrl('/translations/{instanceId}/languages')
  public getDeeplSupportedLanguages(instanceId: string): Observable<IrisDeeplLanguage[]> {
    return this.httpClient.get<IrisDeeplLanguage[]>(this.url({ instanceId })).pipe(
      map(languages => languages.map(lang => new IrisDeeplLanguage(lang.language, lang.name, lang.translatedName))),
    );
  }

  @ApiUrl('/translations/{iris@instanceId}/translate')
  requestTranslations(translations: IrisDeeplPayloadI[]): Observable<IrisDeeplResultI[]> {
    return this.httpClient.post<IrisDeeplResultI[]>(this.url(), translations);
  }

  public getDeeplDefaultLanguages(): IrisDeeplLanguage[] {
    return [
      new IrisDeeplLanguage('BG', 'Bulgarian'),
      new IrisDeeplLanguage('CS', 'Czech'),
      new IrisDeeplLanguage('DA', 'Danish'),
      new IrisDeeplLanguage('DE', 'German'),
      new IrisDeeplLanguage('EL', 'Greek'),
      new IrisDeeplLanguage('EN-GB', 'English (British)'),
      new IrisDeeplLanguage('EN-US', 'English (American)'),
      new IrisDeeplLanguage('ES', 'Spanish'),
      new IrisDeeplLanguage('ET', 'Estonian'),
      new IrisDeeplLanguage('FI', 'Finnish'),
      new IrisDeeplLanguage('FR', 'French'),
      new IrisDeeplLanguage('HU', 'Hungarian'),
      new IrisDeeplLanguage('IT', 'Italian'),
      new IrisDeeplLanguage('JA', 'Japanese'),
      new IrisDeeplLanguage('LT', 'Lithuanian'),
      new IrisDeeplLanguage('LV', 'Latvian'),
      new IrisDeeplLanguage('NL', 'Dutch'),
      new IrisDeeplLanguage('PL', 'Polish'),
      new IrisDeeplLanguage('PT-BR', 'Portuguese (Brazilian)'),
      new IrisDeeplLanguage('PT-PT', 'Portuguese (European)'),
      new IrisDeeplLanguage('RO', 'Romanian'),
      new IrisDeeplLanguage('RU', 'Russian'),
      new IrisDeeplLanguage('SK', 'Slovak'),
      new IrisDeeplLanguage('SL', 'Slovenian'),
      new IrisDeeplLanguage('SV', 'Swedish'),
      new IrisDeeplLanguage('ZH', 'Chinese'),
    ];
  }
}
